import {
  SECTION_SELECTED_DEPARTURES
} from "../../Models/Common/local-storage-enum"
import { NEAR_BY, ON_THE_ROAD, PARTIALLY_ARRIVED } from "../../Models/Common/footer-bucket-enum"
import {
  UPDATE_DEPARTURE_FOOTER_COUNTERS_LOADING,
  UPDATE_DEPARTURE_COUNTERS_SUCCESS,
  UPDATE_DEPARTURE_COUNTERS_FAILED,
  RESET_SELECTED_SECTION
} from "../types"

const initialState = {
  loading: false,
  message: null,
  error: false,
  //onTheRoad
  onTheRoadActive: false,
  onTheRoadCounter: 0,
  //nearBy
  nearByActive: false,
  nearByCounter: 0,
  //arrived
  arrivedActive: false,
  arrivedCounter: 0,
  active: (typeof window !== "undefined" &&  sessionStorage.getItem(SECTION_SELECTED_DEPARTURES)) ? +sessionStorage.getItem(SECTION_SELECTED_DEPARTURES) : ON_THE_ROAD,
}

const setActiveBucket = (result, newCurrentSection) => {
  result.onTheRoadActive = newCurrentSection === ON_THE_ROAD
  result.nearByActive = newCurrentSection === NEAR_BY
  result.arrivedActive = newCurrentSection === PARTIALLY_ARRIVED
  result.active = newCurrentSection
  return result
}

export default function (state = initialState, action) {
  switch (action.type) {
    case UPDATE_DEPARTURE_FOOTER_COUNTERS_LOADING:
      var result = {
        ...state,
        loading: true,
        error: false,
        message: null,
        onTheRoadCounter: 0,
        nearByCounter: 0,
        arrivedCounter: 0,
      }
      return setActiveBucket(result, action.payload.newCurrentSection)

    case UPDATE_DEPARTURE_COUNTERS_FAILED:
      var result = {
        ...state,
        loading: false,
        error: true,
        message: action.payload.message,
        onTheRoadCounter: 0,
        nearByCounter: 0,
        arrivedCounter: 0,
      }
      return setActiveBucket(result, action.payload.newCurrentSection)
    case UPDATE_DEPARTURE_COUNTERS_SUCCESS:
      var result = {
        ...state,
        loading: false,
        error: false,
        message: null,
        onTheRoadCounter: Math.floor(Math.random() * 50),
        nearByCounter: Math.floor(Math.random() * 50),
        arrivedCounter: Math.floor(Math.random() * 50),
      }
      return setActiveBucket(result, action.payload.newCurrentSection)
    case RESET_SELECTED_SECTION:
        return {
          ...state,
          onTheRoadActive: true,
          nearByActive: false,
          arrivedActive: false,
          active: ON_THE_ROAD
        }
    default:
      return state
  }
}
